import { appendSetCookieHeaders } from '../utils/appendSetCookieHeaders.mjs';
import { createUrlSearchParamsForSignInSignUp } from '../utils/createUrlSearchParams.mjs';
import { createAuthorizeEndpoint, createSignUpEndpoint } from '../utils/cognitoHostedUIEndpoints.mjs';
import { createAuthFlowProofCookiesSetOptions, createSignInFlowProofCookies } from '../utils/authFlowProofCookies.mjs';
import { createAuthFlowProofs } from '../utils/createAuthFlowProofs.mjs';
import 'aws-amplify/adapter-core/internals';
import 'aws-amplify/auth/server';
import { isSSLOrigin } from '../utils/origin.mjs';
import 'aws-amplify/adapter-core';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const handleSignInSignUpRequest = ({ request, userPoolClientId, oAuthConfig, customState, origin, setCookieOptions, type, }) => {
    const { codeVerifier, state } = createAuthFlowProofs({ customState });
    const redirectUrlSearchParams = createUrlSearchParamsForSignInSignUp({
        url: request.url,
        oAuthConfig,
        userPoolClientId,
        state,
        origin,
        codeVerifier,
    });
    const headers = new Headers();
    headers.set('Location', type === 'signIn'
        ? createAuthorizeEndpoint(oAuthConfig.domain, redirectUrlSearchParams)
        : createSignUpEndpoint(oAuthConfig.domain, redirectUrlSearchParams));
    appendSetCookieHeaders(headers, createSignInFlowProofCookies({ state, pkce: codeVerifier.value }), createAuthFlowProofCookiesSetOptions(setCookieOptions, {
        secure: isSSLOrigin(origin),
    }));
    return new Response(null, {
        status: 302,
        headers,
    });
};

export { handleSignInSignUpRequest };
//# sourceMappingURL=handleSignInSignUpRequest.mjs.map
